import { Typography } from '@prenuvo/halo-foundation';

import { ActivityLogDetailValue } from '@/api';
import { Editor } from '@/modules/reporting/shared/component';

import { ACTION_CLASSES, ActionClass, EDITOR_FIELDS } from '../activity-log.constant';
import { formatValue, shouldRenderArrow } from '../activity-log.util';

export interface ActivityLogDetailProps {
  action: ActionClass;
  fieldName: string;
  oldValue?: ActivityLogDetailValue;
  title: string;
  value: ActivityLogDetailValue;
}

export function ActivityLogDetail({
  action,
  fieldName,
  oldValue = null,
  title,
  value,
}: ActivityLogDetailProps) {
  const getActionClassName = (className: ActionClass) => ACTION_CLASSES[className] || '';

  return (
    <div className="pb-2">
      <Typography className="pb-2" variant="paragraph-sm">
        {title}
      </Typography>
      <div className="flex">
        {EDITOR_FIELDS.includes(fieldName) ? (
          <>
            {oldValue !== null && (
              <div className={getActionClassName('DELETE')}>
                <Editor isReadOnly value={oldValue as string} />
              </div>
            )}
            {shouldRenderArrow(value, oldValue) && (
              <span className="mx-5" data-testid="arrow-seperator">
                &gt;
              </span>
            )}
            <div className={getActionClassName(action)}>
              <Editor isReadOnly value={value as string} />
            </div>
          </>
        ) : (
          <>
            {oldValue !== null && (
              <Typography className={getActionClassName('DELETE')} variant="paragraph-sm">
                {formatValue(oldValue)}
              </Typography>
            )}
            {shouldRenderArrow(value, oldValue) && (
              <span className="mx-2 leading-none" data-testid="arrow-seperator">
                &gt;
              </span>
            )}
            <Typography className={getActionClassName(action)} variant="paragraph-sm">
              {formatValue(value)}
            </Typography>
          </>
        )}
      </div>
    </div>
  );
}
